/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetterTree } from "vuex";
import { RootState } from "../types";
import { AuthState } from "./types";

export const getters: GetterTree<AuthState, RootState> = {
  token: (state: any) => () => state.token,
};
